import { classNames } from '~/helpers/string'

type DividerProps = React.HTMLAttributes<HTMLHRElement>

function Divider(props: DividerProps) {
  const { className = '', ...rest } = props
  return (
    <hr
      className={classNames('rounded-full border-b-0 border-solid border-brand-neutral-200/60', className)}
      {...rest}
    />
  )
}

export default Divider
